let seq = 0;

/** Stable synthetic key for editable row lists, so text inputs never remount while typing. */
export const rowKey = () => `row_${++seq}`;

export const withRowKeys = (rows) => (rows || []).map((r) => ({ ...r, _k: r._k || rowKey() }));
